module.exports = __webpack_public_path__ + "static/media/assinatura.cd5d39ad.png";